import MicOffIcon from "@mui/icons-material/MicOff";
import { useTheme } from "@mui/material";
import { useRef } from "react";
import { useSelector } from "react-redux";
import { AvatarWrapper, CenterName, Etiqueta } from "../../../../styled/Avatar";

const Avatar = ({
  participant,
  style,
  tieneViewportPocaAltura,
  esParticipanteLocal,
}) => {
  const theme = useTheme();

  const { apellidoNombrePaciente, apellidoNombreProfesional } = useSelector(
    (state) => state.call.call.data,
  );

  const avatarRef = useRef(null);

  const etiquetaNombre =
    participant.displayName === "Paciente"
      ? apellidoNombrePaciente
      : apellidoNombreProfesional;
  const tieneCamaraEncendida = participant.bVideoOn;
  const tieneAudio = participant.audio === "computer";
  const audioDesactivado = participant.audio === "";
  const estaMuteado = participant.muted;
  const estaEnFailover = participant.isInFailover;

  return (
    <AvatarWrapper
      ref={avatarRef}
      style={style}
      isVideoOn={participant.bVideoOn}
      esLocal={esParticipanteLocal}>
      {(tieneCamaraEncendida ||
        (tieneAudio && estaMuteado) ||
        audioDesactivado ||
        estaEnFailover) && (
        <Etiqueta tieneViewportPocaAltura={tieneViewportPocaAltura}>
          {(tieneAudio && estaMuteado) || audioDesactivado ? (
            <MicOffIcon sx={{ color: theme.palette.primary.main }} />
          ) : null}
          {tieneCamaraEncendida && (
            <span>
              {etiquetaNombre.toUpperCase()} {esParticipanteLocal && " (Usted)"}
            </span>
          )}
        </Etiqueta>
      )}
      {!tieneCamaraEncendida && (
        <CenterName variant="h5">{etiquetaNombre.toUpperCase()}</CenterName>
      )}
    </AvatarWrapper>
  );
};

export default Avatar;
